import { useEffect, useState } from 'react'
import logo from '@/assets/logo.svg'

interface PageLoaderProps {
  loading?: boolean
}

export const PageLoader = ({ loading = true }: PageLoaderProps) => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (!loading) return

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) return 90
        return prev + Math.random() * 15
      })
    }, 300)

    return () => clearInterval(interval)
  }, [loading])

  if (!loading) return null

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white dark:bg-gray-900">
      <div className="mx-auto flex max-w-sm flex-col items-center space-y-8 px-4">
        {/* Logo */}
        <div className="relative">
          <img src={logo} alt="Logo" className="h-16 w-auto sm:h-20 md:h-24" />
        </div>

        {/* Loading dots */}
        <div className="flex items-center space-x-2">
          <div
            className="size-2 animate-pulse rounded-full bg-gray-400 dark:bg-gray-500"
            style={{ animationDelay: '0ms' }}
          />
          <div
            className="size-2 animate-pulse rounded-full bg-gray-400 dark:bg-gray-500"
            style={{ animationDelay: '150ms' }}
          />
          <div
            className="size-2 animate-pulse rounded-full bg-gray-400 dark:bg-gray-500"
            style={{ animationDelay: '300ms' }}
          />
        </div>

        {/* Progress bar */}
        <div className="w-full">
          <div className="relative h-1 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
            <div
              className="absolute left-0 top-0 h-full rounded-full bg-blue-600 transition-all duration-300 ease-out dark:bg-blue-500"
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="mt-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400">
            Loading...
          </p>
        </div>
      </div>
    </div>
  )
}

export default PageLoader
